import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export default function SubmitCompleteModal(props) {
  const { yesFn } = props;

  const { t } = useTranslation();

  // Modal 창 스크롤 제어 //
  useEffect(() => {
    document.body.style.cssText = `position: fixed; top: -${window.scrollY}px; width: 100%`

    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = `position: ""; top: "";`
      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
  }, [])

  return (
    <Background>
      <Modal>
        <Text style={{ marginTop: '53px'}} fontFamily='NotoSansKR-Bold' fontSize={16} color='#4F4F4F'>{t('제출이 완료되었습니다.')}</Text>
        <ButtonWrapper>
          <Button onClick={yesFn}>
            {/* <Text fontFamily='NotoSansKR-Bold' fontSize={18} color='#FFFFFF'>{t('순위표 확인하기')}</Text> */}
            <Text fontFamily='NotoSansKR-Bold' fontSize={18} color='#FFFFFF'>{t('확인')}</Text>
          </Button>
        </ButtonWrapper>
      </Modal>
    </Background>
  )
}

const Background = styled.div`
  position: fixed;
	display: flex;
	flex-direction: column;

  justify-content: center;
  align-items: center;

  top: 0;
  left: 0;

  z-index: 500;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.5);
`;

const Modal = styled.div`
	display: flex;
	flex-direction: column;

  justify-content: flex-start;
  align-items: center;

	width: 90.33%;
	height: 202px;
  
	border-radius: 12px;
  background-color: #FFFFFF;
`;

const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 53px;

  width: 85.02%;
`;

const Button = styled.div`
	display: flex;
	flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 60px;

  border-radius: 8px;
  background-color: #6DD49E;

  :hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  padding: 0 0 0 0;
  margin: 0 0 0 0;

  :hover {
    cursor: default;
  }
`;